import { Injectable } from '@angular/core';
import { FormDataService } from '../../../base-data-services/form-data.service';
import { SmApiService } from '../../../../core-services/sm-api.service';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SystemService } from '../../../../core-services/system.service';
import { environment } from 'src/environments/environment';
import { LoginModel } from 'common/models/page-models/Login/login/login-data-model';



@Injectable({
    providedIn: 'root'
})
export class LoginDataService extends FormDataService<LoginModel> {
    constructor(apiService: SmApiService, protected override ss: SystemService) {
        super(API_URL.login, apiService, ss);
    }

    createInstance(): LoginModel {
        return new LoginModel();
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + '',
            method: API_METHODS.get
        }
        return edit;
    }

    override modifyPostModel(formModel: any, dataModel: any) {

        const data = {
            'email' : formModel.email,
            'password' : formModel.password
        }
        return data;
    }

    override afterPostData(model: LoginModel): Promise<LoginModel> {
        return new Promise<LoginModel>((resolve, reject) => {
        //       envelope.type = OperationType.CREATE;
        // envelope.transferData = new WidgetModel();
        // envelope.transferData.email = credentials.userId;
            // this.ss.login(model);
            resolve(this.transformAPIData(model));
        });
    }

    getAuthStatus(): boolean {
        // const username = this.systemService.st(this.systemService.getlocalStorage('username'))
        if (
            // this.ss.getlocalStorage('profile') !== null &&
            // this.ss.getlocalStorage('profile') !== undefined &&
            this.ss.getlocalStorage('token') !== null &&
            this.ss.getlocalStorage('token') !== undefined
        ) {
            return true;
        } else {
            // console.log("else part")
            this.ss.navigateToLogin();
            return false;
        }
    }
    
//   getAuthStatus(): boolean {
//         const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbkRhdGEiOnsiaWQiOjIsInN0YXR1cyI6MSwiZmlyc3RfbmFtZSI6IlUyRnNkR1ZrWDEvQTErUW4wcEFmTDJtNUMwQmk4Z3Fpd29NV2MweE9GTms9IiwibGFzdF9uYW1lIjoiVTJGc2RHVmtYMStIbURkNGxjRkRwb1NoOVBHU1g4UlI1T1h1V09vRTg3cz0iLCJuYW1lIjoiVTJGc2RHVmtYMS9BMStRbjBwQWZMMm01QzBCaThncWl3b01XYzB4T0ZOaz0gVTJGc2RHVmtYMStIbURkNGxjRkRwb1NoOVBHU1g4UlI1T1h1V09vRTg3cz0iLCJlbWFpbCI6InNtcml0aTAzQGdtYWlsLmNvbSIsInJvbGUiOiJTdHVkZW50IiwidGltZSI6IjIwMjQtMDgtMTNUMDY6MjU6NTEuMTQ4WiIsImV4cGlyeV90aW1lIjoiMjAyNC0wOC0xM1QwNjoyNzo1MS4xNDhaIn0sImlhdCI6MTcyMzUzMDM1MSwiZXhwIjoxNzIzNzAzMTUxfQ.zS2e13-MOiJSByRkBDEH501c0o0Amw1X8mp7NKwBEHA';
   
//         if (token) {
//             return true;
//         } else {
//             this.ss.navigateToLogin();
//             return false;
//         }
//     }
 
}
